import { Box } from '@mui/material';

const MenusDisplayContentTab = ({ value, index, children, ...rest }) => {
  return (
    <div
      role="tabpanel"
      hidden={value !== index}
      id={`tabpanel-${index}`}
      data-testid="MenusDisplayContent.Tab"
      {...rest}
    >
      {value === index && <Box mt={2}>{children}</Box>}
    </div>
  );
};

export default MenusDisplayContentTab;
